"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadSource = void 0;
var LeadSource;
(function (LeadSource) {
    LeadSource["WEBSITE"] = "WEBSITE";
    LeadSource["TEST_DRIVE_REQUEST"] = "TEST_DRIVE_REQUEST";
    LeadSource["SELL_CAR_REQUEST"] = "SELL_CAR_REQUEST";
    LeadSource["EXCHANGE_CAR_FORM"] = "EXCHANGE_CAR_FORM";
    LeadSource["SHOWROOM_VISIT"] = "SHOWROOM_VISIT";
    LeadSource["FINANCE_ELIGIBILITY_REQUEST"] = "FINANCE_ELIGIBILITY_REQUEST";
    LeadSource["BANK_VALUATION_REQUEST"] = "BANK_VALUATION_REQUEST";
    LeadSource["FREE_VALUATION"] = "FREE_VALUATION";
    LeadSource["PHONE"] = "PHONE";
    LeadSource["WALK_IN"] = "WALK_IN";
    LeadSource["REFERRAL"] = "REFERRAL";
    LeadSource["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
    LeadSource["OTHER"] = "OTHER";
})(LeadSource = exports.LeadSource || (exports.LeadSource = {}));
